import { mapGetters } from 'vuex';
import UploadImage from '../../share/upload-image/index.vue';
import AreaTree from './area-tree/index.vue';
import HomeService from '@/views/home/service.js';
import Service from '../org-service';
import RegExp from '@/utils/regExp.js';
import LocationSelect from '../../share/location-select/index.vue';
export default {
  components: {
    UploadImage,
    LocationSelect,
    AreaTree
  },
  computed: {
    ...mapGetters([
      'isSignin',
      'userInfo',
      'refresh'
    ])
  },
  data: () => {
    const checkImage = (rule, value, callback) => {
      if (!value.length) {
        return callback(new Error('请上传服务组织照片'));
      }
      callback();
    };
    return {
      ruleForm: {
        serviceOrgAreaCode: '',
        serviceOrgDetailAddress: '',
        isProvideSocialService: null,
        serviceType: [],
        serviceAreaCode: [],
        serviceMobile: '',
        capitalAssets: '',
        machineryCount: '',
        workerCount: '',
        maxServiceArea: '',
        description: '',
        officImage: [],
        tId: '66aaf784247b9fffdb5eba0b'
      },
      serviceRegionDisplay: '',
      defaultImageList: [],
      rules: {
        serviceOrgAreaCode: [
          { required: true, message: '请选择办公场所地址', trigger: 'change'},
          { pattern: /^\d{12}$/, message: '请选择到村', trigger: 'change' }
        ],
        serviceOrgDetailAddress: [{ required: true, message: '请输入具体地址', trigger: 'blur'}],
        isProvideSocialService: [{ required: true, message: '请选择是否提供社会化服务', trigger: 'change'}],
        serviceType: [{ required: true, message: '请选择服务类型', trigger: 'change'}],
        serviceMobile: [
          { required: true, message: '请输入服务电话', trigger: 'blur'},
          { pattern: RegExp.phone, message: '请输入正确的服务电话', trigger: 'blur' }
        ],
        capitalAssets: [
          { required: true, message: '请输入固定资产（万元）', trigger: 'blur'}
        ],
        machineryCount: [
          { required: true, message: '请输入农机具数量（台套）', trigger: 'blur'}
        ],
        workerCount: [
          { required: true, message: '请输入人员数量', trigger: 'blur'}
        ],
        maxServiceArea: [
          { required: true, message: '请输入最大服务面积(亩)', trigger: 'blur'}
        ],
        description: [
          { required: true, message: '请输入服务组织介绍', trigger: 'blur'}
        ],
        serviceAreaCode: [
          { required: true, message: '请选择服务区域', trigger: 'blur'}
        ],
        officImage: [
          { required: true, trigger: 'change', validator: checkImage }
        ]
      },
      areaData: {
        visible: false,
        index: 0,
        areaList: [],
        data: [],
        areaName: ''
      },
      typeList: [],
      companyInfo: {},
      enterpriseNatureList: [],
      submitStatus: '',
      id: ''
    };
  },
  created() {
    if (!this.isSignin) {
      this.$router.push('/signin');
      return;
    }
    this.id = this.$route.query.id;
    Service.getReportEnums({type: 'SERVICE_TYPE'}).then(res => {
      this.typeList = res;
    });
    if (!this.id) {
      if (this.userInfo.type === 1) {
        this.$alert('仅支持农村集体经济组织和单位用户进行信息报备，个人用户无需报备', '提示', {
          confirmButtonText: '确定',
          callback: () => {
            this.$router.back();
          }
        });
        return;
      }
      this.getUserInfo();
    } else {
      this.initOrgInfo();
    }
  },
  methods: {
    initOrgInfo() {
      Service.getPartnerDetail({ id: this.id, type: 'arongqi'}).then(res => {
        this.companyInfo.companyName = res.name;
        this.companyInfo.type = res.orgType;
        this.companyInfo.creditCode = res.creditCode;
        this.companyInfo.addressDetail = res.address;
        this.companyInfo.legalName = res.legalName;
        this.companyInfo.legalIdCard = res.legalId;
        this.companyInfo.assignorMobile = res.reportInfo.registMobile;
        this.companyInfo = { ...this.companyInfo };
        this.ruleForm = {
          tId: '66aaf784247b9fffdb5eba0b',
          orgName: res.name,
          orgType: res.orgType + '',
          uniqueId: res.creditCode,
          registeredDetailAddress: res.registerAddress,
          legalPersonName: res.legalName,
          legalPersonIdCard: res.legalId,
          registMobile: res.reportInfo.registMobile,
          serviceOrgAreaCode: res.reportInfo.serviceInfo.serviceOrgAreaCode,
          serviceOrgDetailAddress: res.reportInfo.serviceInfo.serviceOrgDetailAddress,
          isProvideSocialService: true,
          serviceType: res.typeList,
          serviceAreaCode: res.areaList,
          serviceMobile: res.reportInfo.serviceInfo.serviceMobile,
          capitalAssets: res.reportInfo.serviceInfo.capitalAssets,
          machineryCount: res.reportInfo.serviceInfo.machineryCount,
          workerCount: res.reportInfo.serviceInfo.workerCount,
          maxServiceArea: res.reportInfo.serviceInfo.maxServiceArea,
          description: res.reportInfo.serviceInfo.description,
          officImage: res.coverImg,
          id: res.reportId
        };
        this.defaultImageList = res.coverImg.map(item => {
          return { ...item, url: item.image.url};
        });
        console.log(this.defaultImageList);
        this.serviceRegionDisplay = res.areaListDesc;
      });
    },

    showAreaTreeAction() {
      this.areaData.visible = true;
    },
    getAreaData () {
      Service.getAreaListAll(['451022']).then(response => {
        this.areaData.data = response;
        this.areaData.areaList = ['451022'];
        this.areaData.visible = true;
      });
    },

    setInputNumber(event, key) {
      this.ruleForm[key] = this.getPrice(this.ruleForm[key]);
    },

    getPrice(price) {
      let real = price + '';
      real = real.replace(/[^\d.]/g, '');
      real = real.replace(/^\./g, '');
      real = real.replace(/\.{2,}/g, '.');
      real = real.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      real = real.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
      return real;
    },
    areaChange(area) {
      this.ruleForm.serviceAreaCode = area.areaList;
      this.serviceRegionDisplay = area.area;
      this.areaData.visible = false;
    },
    uploadSuccessImage(image) {
      this.ruleForm.officImage = image;
    },

    getImageUrl(imgUrl, staticUrl) {
      return imgUrl.replace(/^http[s]{0,1}:\/\/.*?\/([0-9a-zA-z\-\_\%\*\;\/\.\u4e00-\u9fa5]+).*?$/, (s, url) => {
        return url.indexOf('oss') === 0 ? url : staticUrl + url;
      });
    },

    areaCodeChange(event) {
      this.ruleForm.serviceOrgAreaCode = event.areaCode;
    },
    getUserInfo() {
      HomeService.getUserBaseInfo().then(res => {
        this.companyInfo = res.data;
        this.ruleForm.orgName = res.data.companyName;
        this.ruleForm.orgType = this.userInfo.type + '';
        this.ruleForm.uniqueId = res.data.creditCode;
        this.ruleForm.registeredDetailAddress = res.data.addressDetail;
        this.ruleForm.legalPersonName = res.data.legalName;
        this.ruleForm.legalPersonIdCard = res.data.legalIdCard;
        this.ruleForm.registMobile = res.data.assignorMobile;
      });
    },
    submit() {
      if (this.submitStatus === 'ongoing') {
        return;
      }
      this.$refs.basicForm.validate((valid) => {
        if (valid) {
          if (this.ruleForm.serviceAreaCode.length < 1) {
            this.$errorMessage('请选择服务区域');
            return;
          }
          this.$confirm('确定提交？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submitStatus = 'ongoing';
            const list = this.ruleForm.officImage.map(item => this.getImageUrl(item.image.url, 'oss/private/'));
            Service.savePartnerRegister({...this.ruleForm, officImage: list}).then(() => {
              this.$router.go(-1);
            }).finally(() => {
              this.submitStatus = '';
            }).catch((error) => {
              console.log(error);
              this.$errorMessage(error.data.reason);
            });
          });
        }
      });
    },

    back() {
      this.$confirm('您确定要返回？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.back();
      });
    }
  }
};
